import axios from "axios";

const sendEmail = async (recipientEmail, subject, emailDetails) => {
  if (!recipientEmail) {
    console.error("Invalid recipient email:", recipientEmail);
    return;
  }

  const subtasksContent = Array.isArray(emailDetails.subtasks) && emailDetails.subtasks.length > 0
  ? `<ul>${emailDetails.subtasks.map((subtask) =>
      `<li>${typeof subtask === 'string' 
          ? subtask 
          : `${subtask.name} - ${subtask.completed ? "Completed" : "Not Completed"}`}</li>`
    ).join("")}</ul>`
  : `N/A`;

  const emailContent = `
    <div style="font-family: Arial, sans-serif; color: #333;">
      <h2 style="color: #1E88E5;">Card Status Updated</h2>
      <p>Dear User,</p>
      <p>The status of the card "<strong>${emailDetails.cardName}</strong>" (ID: ${emailDetails.taskId}) has been updated to "<strong>${emailDetails.newStatus}</strong>".</p>
      <h3>Card Details</h3>
      <ul>
        <li><strong>Description:</strong> ${emailDetails.description}</li>
        <li><strong>Assignee:</strong> ${emailDetails.assigneeName}</li>
        <li><strong>Priority:</strong> ${emailDetails.priority}</li>
        <li><strong>Status:</strong> ${emailDetails.status}</li>
        <li><strong>Due Date:</strong> ${emailDetails.dueDate}</li>
        <li><strong>Estimate:</strong> ${emailDetails.estimate}</li>
        <li><strong>Acceptance Criteria:</strong> ${emailDetails.acceptanceCriteria}</li>
        <li><strong>Assign Date:</strong> ${emailDetails.assignDate}</li>
        <li><strong>Subtasks:</strong> ${subtasksContent}</li>
        </ul>
      <p>You can view the card details <a href="${emailDetails.webAppLink}" style="color: #1E88E5; text-decoration: none;">here</a>.</p>
      <p>Best regards,<br>OVPlan Team</p>
    </div>
  `;

  //const subjectWithTaskId = `Card Status Updated - ID: ${emailDetails.taskId} - ${new Date().toLocaleString()}`;
  // Format date in dd/mon/yyyy hh:mm:ss am/pm <timezone> format
  const formattedDate = new Intl.DateTimeFormat('en-US', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true,
    timeZone: 'Asia/Kolkata', // IST timezone
    timeZoneName: 'short'
  }).format(new Date());

  const subjectWithTaskId = `Card Status Updated - ID: ${emailDetails.taskId} - ${formattedDate}`;


  const jsonPayload = {
    email: recipientEmail,
    subject: subjectWithTaskId,
    textbody: `Card "${emailDetails.cardName}" (ID: ${emailDetails.taskId}) status changed to "${emailDetails.newStatus}".`,
    htmlbody: emailContent,
    apiKey: process.env.REACT_APP_EMAIL_API_KEY,
  };

  const formData = new FormData();
  formData.append("jsonPayload", JSON.stringify(jsonPayload));

  try {
    console.log(`Sending email to ${recipientEmail}...`);
    const response = await axios.post(process.env.REACT_APP_EMAIL_API_URL, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    console.log("Email sent successfully!");
  } catch (error) {
    console.error("Error sending email:", error);
  }
};

export default sendEmail;
